export default {
  home: '/',
  about: '/about',
  activity: '/activity',
  login: '/log-in',
  logout: '/log-out',
  logonScan: '/logon-scan',
  restricted: '/restricted',
  landing: '/landing/:print',

  lineItemRoute: '/line-item',
  lineItem: '/line-item/:uuid',

  materialBatch: '/material-batch',
  materialBatchAction: '/material-batch/:uuid/action',
  materialBatchBlendBatches: '/material-batch/:uuid/action/blend-batches',
  materialBatchMachineLoad: '/material-batch/:uuid/action/machine-load',
  materialBatchMachineUnloadChamber: '/material-batch/:uuid/action/machine-unload-chamber',
  materialBatchMachineUnloadHopper: '/material-batch/:uuid/action/machine-unload-hopper',
  materialBatchRelocate: '/material-batch/:uuid/action/relocate',
  materialBatchScrapBatch: '/material-batch/:uuid/action/scrap-batch',
  materialBatchSieve: '/material-batch/:uuid/action/sieve',
  materialBatchSplitBatch: '/material-batch/:uuid/action/split-batch',
  materialBatchStartTest: '/material-batch/:uuid/action/start-test',
  materialBatchUnloadReclaimedMaterial: '/material-batch/:uuid/action/unload-reclaimed-material',
  materialBatchSuccess: '/material-batch/:uuid/success',

  materialContainerCreateInitialBatch: '/material-container/:uuid/create-initial-batch',
  materialContainerDetails: '/material-container/:uuid',
  materialContainer: '/material-container',

  piece: '/piece/:uuid',
  pieceOverview: '/piece-overview/:uuid',

  printer: '/printer',
  printerAlreadyLoaded: '/printer/:uuid/already-loaded',
  printerMaterial: '/printer/:uuid/material',
  lpsPage: '/printer/:uuid/lps',
  printerLoadMaterialBatchAction: '/printer/:uuid/action/load-material-batch',
  printerLoadMaterialAction: '/printer/:uuid/action/load-material',
  printerSuccess: '/printer/:uuid/success',
  printerMaintenance: '/printer/:uuid/maintenance',

  runRoute: '/run',
  run: '/run/:uuid',

  toolRoute: '/tool',
  tool: '/tool/:uuid',

  permanentContainer: '/permanent-container',
  mLine: '/mLine',
  postProcessor: '/post-processor',
  postProcessorDetails: '/post-processor/:uuid',
  mLineLps: '/lps',
  mLineMhs: '/mhs',
  mhsPage: '/post-processor/:uuid',
  postProcessorQueue: '/post-processor/:uuid/queue',
  postProcessorMaintenance: '/post-processor/:uuid/maintenance',
  permanentContainerDetails: '/permanent-container/:uuid',
  permanentContainerAction: '/permanent-container/:uuid/action',
  permanentContainerActionSplit: '/permanent-container/:uuid/action/split',
  permanentContainerScrapAction: '/permanent-container/:uuid/action/scrap-container',
  permanentContainerLoadMaterialBatchAction:
    '/permanent-container/:uuid/action/load-material-batch',
  permanentContainerActionSieve: '/permanent-container/:uuid/action/sieve',
  permanentContainerLoadMaterialAction: '/permanent-container/:uuid/action/load-material',
  permanentContainerActionRelocate: '/permanent-container/:uuid/action/relocate',
  permanentContainerUnloadAction: '/permanent-container/:uuid/action/action-unload-to-container',
  permanentContainerActionContainerUnload:
    '/permanent-container/:uuid/action/action-container-unload',
  permanentContainerLoadAction: '/permanent-container/:uuid/action/load-material',
  permanentContainerUnloadCyclone: '/permanent-container/:uuid/action/unload-cyclone',
  runAction: '/run/:uuid/action',
  toolAction: '/tool/:uuid/action',
  toolMaintenance: '/tool/:uuid/maintenance',
  permanentContainerAlreadyLoaded: '/permanent-container/:uuid/already-loaded',
  permanentContainerSuccess: '/permanent-container/:uuid/success',

  shipment: '/shipment/:uuid',

  travelerPrint: '/traveler/print/:print',
  travelerRun: '/traveler/run/:run',
  travelerCompactRun: '/traveler-compact/run/:run',
  travelerContainers: '/traveler/qr-codes',

  scan: '/scan',
  summary: '/summary',
  productionChange: '/run/:uuid/action/production-change',
};
